module.exports = __webpack_public_path__ + "static/media/home-depot-small.e3c8ae4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/home-depot-small.png
// module id = 777
// module chunks = 27